export const css = {
    container: '_-7INjQJM',
    root: 'VxwP3rED',
    ' _key': 'mc-widgets/hero'
};
export default css;
